import { render, staticRenderFns } from "./levelShow.vue?vue&type=template&id=6b392f05&scoped=true"
import script from "./levelShow.vue?vue&type=script&lang=js"
export * from "./levelShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b392f05",
  null
  
)

export default component.exports